import { FC } from 'react';

import Modal from '@z-components/atoms/Modal';

import styles from './BadgeExplanationModal.module.scss';

const TRANSLATIONS = {
  en: {
    badgeExplanationText:
      'We ask pros to submit their IDs, phone numbers, and email addresses to Zehitomo for verification.',
    whatIsVerifiedInfo: 'What is verified info?',
  },
  ja: {
    badgeExplanationText:
      'プロの方に対し身分証明書・電話番号・メールアドレスをゼヒトモにご提出いただき、運営側にて認証業務を実施しています。認証済情報はお客様に安心してお届けできます。',
    whatIsVerifiedInfo: '認証情報とは？',
  },
};

interface Props {
  handleModalDismiss: () => void;
  language: 'en' | 'ja';
}
const BadgeExplanationModal: FC<Props> = ({ handleModalDismiss, language }) => (
  <Modal
    modalName="verification-help"
    hasMaxWidth={true}
    isCloseButtonHidden={true}
    isModalRounded={true}
    onDismiss={handleModalDismiss}
  >
    <div className={styles['verified-badges-container']}>
      <img alt="Government Id verified" src="/static/images/icons/govt-id-verification-on.svg" />
      <img alt="Phone number verified" src="/static/images/icons/phone-verification-on.svg" />
      <img alt="Email verified" src="/static/images/icons/mail-verification-on.svg" />
    </div>
    <p className={styles['modal-title']}>{TRANSLATIONS[language].whatIsVerifiedInfo}</p>
    <p className={styles['modal-content']}>{TRANSLATIONS[language].badgeExplanationText}</p>
  </Modal>
);
export default BadgeExplanationModal;
export type { Props as BadgeExplanationModal };
